<p-table
	#dt
	styleClass="p-datatable-responsive-demo"
	[value]="venueService.venueFinance.value?.invoices"
	[loading]="!venueService.venueFinance.value?.invoices"
	[globalFilterFields]="app.keys(venueService.venueFinance.value?.invoices)"
	[scrollable]="true"
	[rows]="100"
	scrollHeight="700px"
	[virtualScroll]="true"
	[virtualRowHeight]="40"
>
	<ng-template pTemplate="caption">
		<div class="table-header d-flex">
			<div class="flex-grow-1">
				<span class="p-float-label p-input-icon-left m-2 w-100">
					<i class="pi pi-search"></i>
					<input
						pInputText
						class="w-100"
						id="globalSearch"
						name="globalSearch"
						style="width: 100%"
						type="text"
						(input)="dt.filterGlobal($event.target.value, 'contains')"
					/>
					<label for="globalSearch">Search...</label>
				</span>
			</div>
		</div>
	</ng-template>
	<ng-template pTemplate="header">
		<tr>
			<th pSortableColumn="invoiceNumber">
				Invoice #
				<p-sortIcon field="invoiceNumber"></p-sortIcon>
			</th>
			<th pSortableColumn="createdDate">
				Date
				<p-sortIcon field="createdDate"></p-sortIcon>
			</th>
			<th pSortableColumn="dueDate">
				Due
				<p-sortIcon field="dueDate"></p-sortIcon>
			</th>
			<th pSortableColumn="total">
				Total
				<p-sortIcon field="total"></p-sortIcon>
			</th>
			<th pSortableColumn="balanceDue">
				Balance Due
				<p-sortIcon field="balanceDue"></p-sortIcon>
			</th>
		</tr>
	</ng-template>
	<ng-template let-rec pTemplate="body">
		<tr (click)="invoiceChange.emit(rec)">
			<td>
				{{ rec.invoiceNumber }}
			</td>
			<td>
				{{ app.moment(rec.createdDate).format("l") }}
			</td>
			<td>
				{{ app.moment(rec.dueDate).format("l") }}
			</td>
			<td>
				{{ rec.total | currency }}
			</td>
			<td>
				{{ rec.balanceDue | currency }}
			</td>
		</tr>
	</ng-template>
</p-table>
